import React from "react";
import "./Footer.css";

function Footer() {
  return (
    <div className="footerContainer">
      <p>Footer</p>
    </div>
  );
}

export default Footer;
